import PaginatedComponent from 'core/PaginatedComponent';
import clone from 'lodash/clone';
import { createCustomSlice } from 'core/utils';
import { getStatus } from 'shared/fixtures';
import moment from 'moment';
import { objectShrink } from 'shared/utils';

const initialState = {
    callsLoading: false,
    callsPage: null,
    callsRender: 0,
    professionals: [],
    professionalsLoading: false,
    professionalsPage: null,
    professionalsRender: 0,
    refreshCalls: false,
    tracking: {
        call_id: 0,
        connections: [],
        display: false,
        otErrors: [],
        track: []
    }
};

const dashboardSlice = createCustomSlice({
    initialState,
    name: 'dashboard',
    reducers: {
        setDashboardCallsPage (state, { payload }) {
            state.callsPage = new PaginatedComponent({
                ...payload,
                dataParser: parseCalls,
                loadingAction: dashboardActions.setDashboardCallsLoading,
                setAction: dashboardActions.setDashboardCallsPage
            });
        },
        setDashboardProfessionalsPage (state, { payload }) {
            state.professionalsPage = new PaginatedComponent({
                ...payload,
                dataParser: parseProfessionals,
                loadingAction: dashboardActions.setDashboardProfessionalsLoading,
                setAction: dashboardActions.setDashboardProfessionalsPage
            });
        }
    },
    saga: [
        'getDashboardCalls',
        'getDashboardProfessionals',
        'getDashboardTracking',
        'handleSocketEvent',
        'setDashboardSockets'
    ]
});

const parseCalls = list => {
    const result = clone(list);
    if (!!result) {
        result.forEach(call => parseDoctors(call));
        return result;
    } else {
        return [];
    }
};

export const parseDoctors = call => {
    const { created_at, doctors, status, type } = call;
    if (type === 'call' && !!doctors && doctors.length > 0) {
        doctors.forEach(doctor => {
            doctor.status = getStatus(status, doctor.call_status, moment(created_at));
        });
        return;
    }
    if (type === 'evolution') {
        doctors.status = getStatus('Evolution');
        call.doctors = [doctors];
        call.status = 'Evolution';
    }
};

const parseProfessionals = list => {
    const result = clone(list);
    if (!!result) {
        return result.map(professional => ({ ...objectShrink(professional, [
            'avatar_thumbnail',
            'enrollments',
            'first_name',
            'last_name',
            'id',
            'status',
            'waiting_for_call'
        ]),
        avatar_thumbnail: professional?.avatar_thumbnail?.url
        }));
    } else {
        return [];
    }
};

export const dashboardActions = dashboardSlice.actions;

export default dashboardSlice.reducer;
